import { FiscalYear } from '../entities/fiscalYear';
import { ExecutingUnit } from '../entities/executingUnit';
import { Hhelpdesk } from '../entities/hhelpdesk';
import { Injectable, Injector } from '@angular/core';
import { ReportPayrollRunSummary } from '../entities/report-payroll-run-summary';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Vars } from '../model/vars';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';

interface ExtraSearchFields {
  object?: any;
  fiscalYear?: FiscalYear,
  executingUnit?: ExecutingUnit,
  monthBegin?: Hhelpdesk,
  monthEnd?: Hhelpdesk
}

@Injectable()
export class ReportPayrollRunSummaryService extends BaseReportService<ReportPayrollRunSummary> {

  public uri = '/api/reportPayrollRunSummary/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance ReportPayrollRunSummaryService');
  }

  buildSentence(entity?: ReportPayrollRunSummary, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.fiscalYear ?
          `fiscalYear.id${QueryOperator.Equal}${extraSearchFields.fiscalYear.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.monthBegin ?
          `monthBegin.id${QueryOperator.Equal}${extraSearchFields.monthBegin.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.monthEnd ?
          `monthEnd.id${QueryOperator.Equal}${extraSearchFields.monthEnd.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      ////console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  searchToViewTable(   fiscalYear: any,
    executingUnit: any,
    monthBegin: any,
    monthEnd: any,
    object: Vars
    ): Observable<any> {
      const params = new HttpParams()
        .set('fiscalYearId', fiscalYear)
        .set('euId', executingUnit)
        .set('monthBeginId', monthBegin)
        .set('monthEndId', monthEnd)
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`;
        return this.httpClient.post<any>(url, object, {params}, )
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            return response;
          })
       );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-payroll-run-summary.service.ts